module.exports = __webpack_public_path__ + "static/img/trade2.9e56d891.png";